import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/overstockInventoryCycleCountDifferenceReport'
import Component from 'components/Reports/OverstockInventoryCycleCountDifferenceReport'

export default createListViewContainer({
  actions,
  selectors: selectors.overstockInventoryCycleCountDifferenceReport,
})(Component)
